import { typographyToCss } from 'shared/lib/mui';
import { QueryNavLink } from 'shared/lib/react-router-dom';
import styled, { css } from 'styled-components';

export const Container = styled.div<{
  $isGrabbable: boolean;
  $isGrabbed: boolean;
}>`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(1.5)}`};
  width: 100%;

  border-radius: ${({ theme }) => theme.spacing(2)};
  cursor: ${({ $isGrabbed }) => ($isGrabbed ? 'grabbing' : 'default')};

  color: ${({ theme }) => theme.palette.grey[400]};

  ${({ theme, $isGrabbable }) =>
    $isGrabbable &&
    css`
      &:hover {
        background: ${theme.palette.grey[50]};
      }
    `};
`;

export const Content = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};

  min-width: 0;

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const IconContainer = styled.span<{
  $color: string | null | undefined;
  $noBackground: boolean;
}>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  min-height: 2rem;

  border-radius: ${({ theme }) => theme.spacing(1.5)};
  background: ${({ theme, $noBackground }) =>
    $noBackground ? 'transparent' : theme.palette.grey[100]};

  color: ${({ theme }) => theme.palette.grey[700]};
  font-size: 1.2rem;
  line-height: 62.5%;

  ${({ $color }) =>
    $color &&
    css`
      &::before {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;

        width: 0.6rem;
        height: 0.6rem;

        background: ${$color};
        border-radius: 50%;
        border: 1px solid ${({ theme }) => theme.palette.common.white};
        transform: translate(33%, 33%);
      }
    `}

  ${({ $noBackground }) =>
    $noBackground &&
    css`
      font-size: 1.6rem;
    `};
`;
export const ChevronContainer = styled.span`
  opacity: 0;
  transform: rotate(180deg);
  transition: opacity 200ms;

  line-height: 62.5%;
  font-size: 1.6rem;
  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const TitleContainer = styled(QueryNavLink)`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing(0.25)} 0`};

  min-width: 0;

  text-decoration: none;
  color: inherit;

  &:hover {
    ${ChevronContainer} {
      opacity: 1;
    }
  }
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.h6)};

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;
